import { Fire } from "@phosphor-icons/react";

export const tierOf = (score) => (score >= 15 ? "hot" : score >= 5 ? "warm" : score > 0 ? "cool" : "cold");

export const formatScore = (v) => (Math.floor((Number(v) || 0) * 10) / 10).toFixed(1);

const STYLES = {
  hot: "bg-rose-50 text-rose-700 border-rose-200",
  warm: "bg-amber-50 text-amber-700 border-amber-200",
  cool: "bg-sky-50 text-sky-700 border-sky-200",
  cold: "bg-zinc-100 text-zinc-500 border-zinc-200",
};

export const TierBadge = ({ score, testid }) => {
  const t = tierOf(score || 0);
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full border text-[10px] font-semibold capitalize ${STYLES[t]}`}>
      {t === "hot" && <Fire size={10} weight="fill" />}{t}
    </span>
  );
};
